module.exports = __webpack_public_path__ + "static/media/coffee.edee57fe.svg";